// extracted by mini-css-extract-plugin
module.exports = {"ThreeJsBackground":"ThreeJsBackground_ThreeJsBackground__5ipKu"};